// src/services/userService.js
import { domain } from "../auth/domain";

const getAuthHeaders = () => {
  const token = localStorage.getItem("accessToken");
  return {
    "Content-Type": "application/json",
    Authorization: `JWT ${token}`,
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || "An API error occurred");
  }
  // For DELETE requests which might not have a body
  if (response.status === 204) {
    return null;
  }
  return response.json();
};

export const fetchUsers = async () => {
  const response = await fetch(`${domain}auth/users/`, {
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const fetchRoles = async () => {
  // Note: This endpoint needs to be created on the backend to list Django Groups
  const response = await fetch(`${domain}auth/roles/`, {
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const createUser = async (userData) => {
  const response = await fetch(`${domain}auth/users/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(userData),
  });
  return handleResponse(response);
};

export const updateUser = async (userId, userData) => {
  const response = await fetch(`${domain}auth/users/${userId}/`, {
    method: "PATCH", // Use PATCH to allow partial updates
    headers: getAuthHeaders(),
    body: JSON.stringify(userData),
  });
  return handleResponse(response);
};

export const deleteUser = async (userId) => {
  const response = await fetch(`${domain}auth/users/${userId}/`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const setTemporaryPassword = async (userId, temporaryPassword) => {
  const response = await fetch(
    `${domain}auth/admin/users/${userId}/set-temporary-password/`,
    {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({ temporary_password: temporaryPassword }),
    }
  );
  return handleResponse(response);
};
